import LegalDocumentPage, { type LegalSection } from './legal/LegalDocumentPage';

const sections: LegalSection[] = [
    {
        id: 'controlador-operador',
        title: 'Quem somos e papéis na LGPD',
        children: (
            <>
                <p>
                    Esta Política de Privacidade descreve como a NAPOLI SOFTWARE DEVELOPMENT LTDA,
                    CNPJ 55.764.444/0001-95, responsável pela plataforma LaudoPsi, trata dados
                    pessoais quando você utiliza nossos serviços.
                </p>
                <p>
                    Para dados de conta, autenticação, cobrança, segurança, suporte, métricas de uso
                    e operação da plataforma, a LaudoPsi atua como controladora dos dados.
                </p>
                <p>
                    Para dados de pacientes, anamneses, respostas de questionários, testes
                    psicológicos, resultados clínicos e conteúdo de laudos inseridos ou gerenciados
                    por psicólogos, o psicólogo ou a instituição profissional é, em regra, o
                    controlador. Nesses casos, a LaudoPsi atua como operadora, tratando os dados
                    conforme instruções do profissional e para viabilizar a prestação do serviço.
                </p>
                <p>
                    O canal oficial para solicitações de privacidade e LGPD é contato@laudopsi.com.
                </p>
            </>
        ),
    },
    {
        id: 'dados-tratados',
        title: 'Dados que tratamos',
        children: (
            <>
                <p>
                    Podemos tratar as seguintes categorias de dados, conforme o uso da plataforma:
                </p>
                <h3>Dados do profissional</h3>
                <ul>
                    <li>
                        Nome, email, CPF, CRP, estado do CRP, título profissional, telefone, site,
                        Instagram e endereço profissional quando informados.
                    </li>
                    <li>
                        Preferências de customização de laudos, incluindo logotipo, papel timbrado,
                        temas visuais, fontes e cores.
                    </li>
                    <li>
                        Dados de assinatura, plano, limites de uso, faturas e identificadores de
                        cliente em provedores de pagamento.
                    </li>
                </ul>
                <h3>Dados de pacientes</h3>
                <ul>
                    <li>
                        Nome, data de nascimento, gênero, cidade, escolaridade, email, telefone,
                        endereço, profissional solicitante e avatar técnico.
                    </li>
                    <li>
                        Informações clínicas, histórico, queixas, observações comportamentais,
                        respostas de anamneses e questionários.
                    </li>
                    <li>
                        Testes psicológicos aplicados, respostas, escores, classificações, tabelas,
                        gráficos, hipóteses diagnósticas, recomendações e conteúdo de laudos.
                    </li>
                    <li>
                        Arquivos enviados para anamnese ou apoio documental, como DOCX ou TXT,
                        quando o profissional utiliza essa funcionalidade.
                    </li>
                </ul>
                <h3>Dados técnicos e operacionais</h3>
                <ul>
                    <li>
                        Registros de autenticação, tokens técnicos, cookies de sessão, logs de erro,
                        eventos de segurança e métricas de uso.
                    </li>
                    <li>
                        Histórico de consumo de IA, como tokens utilizados, seção solicitada e
                        informações necessárias para controle de limites.
                    </li>
                    <li>
                        Feedbacks enviados pelo usuário, incluindo nota, comentário e metadados
                        mínimos para análise de melhoria.
                    </li>
                </ul>
            </>
        ),
    },
    {
        id: 'coleta',
        title: 'Como coletamos os dados',
        children: (
            <>
                <p>Os dados são coletados quando:</p>
                <ul>
                    <li>Você cria conta, autentica-se, atualiza perfil ou contrata um plano.</li>
                    <li>
                        Você cadastra pacientes, cria laudos, registra observações, aplica testes ou
                        envia anamneses digitais.
                    </li>
                    <li>
                        Pacientes acessam links públicos seguros para responder questionários ou
                        testes enviados pelo profissional.
                    </li>
                    <li>
                        Você faz upload de arquivos, logotipo, papel timbrado ou documentos para
                        processamento.
                    </li>
                    <li>Você solicita geração, reescrita ou consolidação com IA.</li>
                    <li>
                        Nossos sistemas registram eventos técnicos necessários para segurança,
                        diagnóstico e operação da plataforma.
                    </li>
                </ul>
            </>
        ),
    },
    {
        id: 'finalidades-bases',
        title: 'Finalidades e bases legais',
        children: (
            <>
                <p>
                    Tratamos dados pessoais para operar o LaudoPsi, entregar funcionalidades
                    contratadas, proteger a plataforma, cumprir obrigações legais e melhorar a
                    experiência dos usuários.
                </p>
                <p>
                    As bases legais aplicáveis podem incluir execução de contrato ou procedimentos
                    preliminares, cumprimento de obrigação legal ou regulatória, legítimo interesse,
                    consentimento quando aplicável e exercício regular de direitos.
                </p>
                <p>
                    Dados de saúde, avaliações psicológicas e demais dados sensíveis são tratados
                    com base nas hipóteses previstas no art. 11 da LGPD, incluindo tutela da saúde
                    por profissional habilitado, cumprimento de obrigação legal ou regulatória,
                    exercício regular de direitos, consentimento quando necessário e execução de
                    políticas ou serviços relacionados à atuação profissional do psicólogo.
                </p>
                <p>
                    Quando o psicólogo atua como controlador dos dados de pacientes, cabe a ele
                    definir a base legal adequada para coleta e uso dessas informações no contexto
                    profissional.
                </p>
            </>
        ),
    },
    {
        id: 'ia-desidentificacao',
        title: 'IA, desidentificação e revisão profissional',
        children: (
            <>
                <p>
                    O LaudoPsi oferece recursos de inteligência artificial para auxiliar na
                    elaboração, aprimoramento e consolidação de seções do laudo. A IA é uma
                    ferramenta de apoio à escrita e organização técnica, não substitui a avaliação
                    profissional do psicólogo e não emite diagnóstico de forma autônoma.
                </p>
                <p>
                    Antes de enviar conteúdo textual clínico a modelos externos de IA, aplicamos
                    mecanismos de desidentificação para remover ou substituir identificadores
                    diretos e indiretos, como nomes, documentos, contatos, endereços, instituições e
                    outras informações sensíveis, sempre que esses dados forem detectáveis pelo
                    sistema.
                </p>
                <p>
                    Os textos podem ser processados por fornecedores de IA, como OpenAI, para gerar
                    respostas solicitadas pelo profissional. O profissional deve revisar, editar e
                    aprovar qualquer conteúdo antes de incorporá-lo ao laudo.
                </p>
                <p>
                    Mesmo com medidas de desidentificação, recomendamos que usuários evitem inserir
                    dados identificáveis desnecessários em prompts, campos livres e solicitações de
                    IA.
                </p>
            </>
        ),
    },
    {
        id: 'operadores',
        title: 'Compartilhamento com operadores',
        children: (
            <>
                <p>
                    Não vendemos dados pessoais. Podemos compartilhar dados com fornecedores
                    estritamente necessários para operar o serviço:
                </p>
                <ul>
                    <li>Auth0, para autenticação, identidade e segurança de acesso.</li>
                    <li>
                        Stripe, para checkout, assinaturas, portal do cliente, pagamentos e faturas.
                        Dados completos de cartão são tratados pelo Stripe, não pela LaudoPsi.
                    </li>
                    <li>
                        AWS, para armazenamento de arquivos, filas de processamento, infraestrutura
                        e serviços técnicos relacionados.
                    </li>
                    <li>
                        OpenAI, para processamento de solicitações de IA quando o usuário aciona
                        esse recurso.
                    </li>
                    <li>Sentry, para monitoramento de erros, estabilidade e desempenho.</li>
                    <li>Dicebear, para geração de avatar técnico a partir de seed não clínica.</li>
                </ul>
                <p>
                    Também poderemos compartilhar dados quando necessário para cumprir obrigação
                    legal, ordem de autoridade competente, exercício regular de direitos ou proteção
                    da segurança da plataforma.
                </p>
            </>
        ),
    },
    {
        id: 'transferencia-internacional',
        title: 'Transferência internacional',
        children: (
            <>
                <p>
                    Alguns fornecedores podem armazenar ou processar dados fora do Brasil. Quando
                    houver transferência internacional, adotamos medidas compatíveis com a LGPD,
                    incluindo uso de fornecedores com padrões reconhecidos de segurança, contratos,
                    controles técnicos e limitação de finalidade.
                </p>
                <p>
                    Ao utilizar recursos de autenticação, pagamento, monitoramento, infraestrutura
                    ou IA, certos dados podem ser processados em ambientes internacionais conforme a
                    arquitetura desses fornecedores.
                </p>
            </>
        ),
    },
    {
        id: 'cookies-tokens',
        title: 'Cookies, tokens e links públicos',
        children: (
            <>
                <p>
                    Usamos cookies e identificadores técnicos para manter sessões, proteger acessos
                    e permitir que pacientes respondam questionários ou testes por links seguros,
                    sem criar conta.
                </p>
                <p>
                    Links enviados a pacientes usam tokens de acesso e podem criar cookies de sessão
                    com configurações de segurança, como httpOnly, secure, sameSite e expiração.
                    Esses mecanismos ajudam a reduzir acesso indevido e abuso.
                </p>
                <p>
                    Também utilizamos controles de taxa de requisições para proteger endpoints
                    públicos e reduzir tentativas automatizadas ou uso abusivo.
                </p>
            </>
        ),
    },
    {
        id: 'seguranca',
        title: 'Segurança da informação',
        children: (
            <>
                <p>
                    Adotamos medidas técnicas e organizacionais para proteger os dados tratados no
                    LaudoPsi, incluindo:
                </p>
                <ul>
                    <li>Autenticação via provedor especializado e validação de tokens.</li>
                    <li>Criptografia de campos sensíveis e tokens técnicos.</li>
                    <li>Isolamento lógico de dados por usuário e controles de autorização.</li>
                    <li>URLs assinadas e escopo restrito para upload de arquivos.</li>
                    <li>
                        Pipeline de desidentificação para arquivos e conteúdos clínicos usados em
                        fluxos de IA.
                    </li>
                    <li>Monitoramento de erros, registros técnicos e limites de requisição.</li>
                </ul>
                <p>
                    Nenhum sistema é absolutamente imune a incidentes. Caso identifique
                    vulnerabilidade, acesso indevido ou suspeita de incidente, entre em contato
                    imediatamente pelo email contato@laudopsi.com.
                </p>
            </>
        ),
    },
    {
        id: 'retencao-eliminacao',
        title: 'Retenção e eliminação',
        children: (
            <>
                <p>
                    Reteremos dados pelo tempo necessário para cumprir as finalidades desta
                    política, prestar o serviço, manter registros de segurança, atender obrigações
                    legais, resolver disputas e preservar direitos.
                </p>
                <p>
                    Arquivos de anamnese processados por fluxos de desidentificação podem ter o
                    arquivo original removido após a conclusão do processamento, mantendo apenas
                    conteúdo desidentificado e registros técnicos necessários.
                </p>
                <p>
                    Dados de cobrança e assinatura podem ser mantidos conforme exigências legais,
                    contábeis, fiscais e de prevenção a fraude. Backups e logs técnicos podem
                    permanecer por período limitado até sua expiração operacional.
                </p>
            </>
        ),
    },
    {
        id: 'direitos-titulares',
        title: 'Direitos dos titulares',
        children: (
            <>
                <p>
                    Nos termos da LGPD, titulares podem solicitar confirmação de tratamento, acesso,
                    correção, anonimização, bloqueio, eliminação, portabilidade, informação sobre
                    compartilhamentos e revisão de decisões automatizadas quando aplicável.
                </p>
                <p>
                    Solicitações devem ser enviadas para contato@laudopsi.com. Poderemos solicitar
                    informações adicionais para confirmar identidade, autoridade ou legitimidade do
                    pedido.
                </p>
                <p>
                    Quando a solicitação envolver dados de paciente controlados pelo psicólogo,
                    poderemos orientar o titular a contatar o profissional responsável ou encaminhar
                    a solicitação conforme a relação aplicável entre controlador e operador.
                </p>
            </>
        ),
    },
    {
        id: 'menores',
        title: 'Dados de crianças e adolescentes',
        children: (
            <>
                <p>
                    O LaudoPsi pode ser utilizado por psicólogos para avaliações envolvendo crianças
                    e adolescentes. Nesses casos, o profissional é responsável por observar as
                    normas éticas e legais aplicáveis, inclusive quanto à participação de
                    responsáveis legais e à adequação da coleta de dados.
                </p>
                <p>
                    Tratamos esses dados apenas para viabilizar a prestação do serviço ao
                    profissional, respeitando a finalidade clínica informada e os controles de
                    segurança aplicáveis.
                </p>
            </>
        ),
    },
    {
        id: 'incidentes',
        title: 'Incidentes de segurança',
        children: (
            <>
                <p>
                    Em caso de incidente de segurança com risco ou dano relevante aos titulares,
                    avaliaremos o evento, adotaremos medidas de contenção e comunicação e, quando
                    exigido, notificaremos as autoridades competentes e os titulares afetados nos
                    termos da legislação aplicável.
                </p>
                <p>
                    Comunicações de vulnerabilidade ou suspeita de incidente devem ser enviadas para
                    contato@laudopsi.com com o máximo de detalhes possível.
                </p>
            </>
        ),
    },
    {
        id: 'alteracoes',
        title: 'Alterações desta política',
        children: (
            <>
                <p>
                    Podemos atualizar esta Política de Privacidade para refletir mudanças no
                    produto, em fornecedores, na legislação ou em práticas internas. Quando houver
                    alteração relevante, poderemos comunicar usuários por meios apropriados dentro
                    da plataforma ou por email.
                </p>
                <p>A versão vigente será sempre disponibilizada nesta página.</p>
            </>
        ),
    },
];

export default function PrivacyPolicy() {
    return (
        <LegalDocumentPage
            title="Política de Privacidade"
            description="Como o LaudoPsi trata dados de psicólogos, pacientes, avaliações psicológicas, arquivos, assinaturas e recursos de inteligência artificial."
            updatedAt="28 de abril de 2026"
            version="v1.0"
            sections={sections}
        />
    );
}
